/**
 * Home Hero: play the looping media video unless the visitor prefers reduced motion.
 */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (video) => {
    const update = () => {
      if (motion.matches) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    };
    motion.addEventListener('change', update);
    update();
  };

  const boot = () => document.querySelectorAll('[data-home-hero-video]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
